import * as React from 'react';
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Box } from '@mui/material';
import StyledTableContainer from '../../../components/StyledTableContainer';
import BackButton from '../../../components/BackButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { formatDateWithJs, isNotEmpty } from '../../../utils/format';
import { getProdStockListServ } from '../../../services/amtc-service';
import { useEffect } from 'react';
import { customAlert } from '../../../components/notify';
import route from '../../../utils/Routes';

function CompProdStockList() {
  const navigate = useNavigate();
  const { setLoadingScreen } = useAuthContext();
  const [searchParams] = useSearchParams();
  const prodId = searchParams.get("prodId") || "";
  const { isLoading, isError, error, data: stockData } = useQuery([QueryKey.prodStockList, prodId],
    () => getProdStockListServ(prodId), {
    enabled: isNotEmpty(prodId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    keepPreviousData: true
  });


  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const columns = [
    {
      id: 'amtcProdIdStrg',
      label: "AMTC Product Ref Id",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'comName',
      label: "Company",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'comProdIdStrg',
      label: "Material Code",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'priceAgreeId',
      label: "Price Agreement ID",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'agreedFrom',
      label: "Agreed From",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'agreedTo',
      label: "Agreed To",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'agreedQty',
      label: "Agreed Quantity",
      align: 'left',
      minWidth: 150,
    },
    {
      id: 'AgreedPrice',
      label: "Price (OMR)",
      align: 'cenleftter',
      minWidth: 100,
    },
    {
      id: 'comProdTax',
      label: "Tax(%)",
      align: 'left',
      minWidth: 10,
    },
  ];

  function handleRowClick(i) {
    navigate(`${route.aComProdInfo}/?prodId=${i?.amtcProdIdStrg}&comId=${i?.comId}`);
  }

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }
  return (
    <Box height={"90%"} width={"100%"} px={0.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1, mb: 2 }} width={"100%"}>
        <Stack width={"33%"} >
          <BackButton />
        </Stack>
        <Stack width={"33%"} alignItems={"center"}>
          <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Company Product Stock List</Typography>
        </Stack>
        <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
        </Stack>
      </Stack>

      {stockData && <StyledTableContainer height={"100%"} isStickyHeader={true}>
        <TableHead>
          <TableRow >
            {columns.map((column) => (
              <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(stockData || []).map((i) => {
            return (
              <React.Fragment key={i?.id}>
                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i)}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                  {columns.map((column) => {
                    const value = i[column.id];
                    switch (column.id) {
                      case "agreedFrom":
                      case "agreedTo":
                        return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          {formatDateWithJs(value)}
                        </TableCell>
                      default:
                        return (
                          <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                            {(value === null || value === "" || value === "null") ? "NA" : value}
                          </TableCell>
                        );
                    }
                  })}
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </StyledTableContainer>}
    </Box>
  );
}

export default CompProdStockList;